<template>
  <div class="search_container">
    <h1 class="font1 margin_bottom">
      {{ tabName }}
    </h1>
    <div class="wrap_search">
      <div class="wrap_slot">
        <slot />
      </div>
      <div class="wrap_button">
        <div>
          <Button
            type="primary"
            ghost
            class="button"
            @click="click_search"
          >
            查询
          </Button>
          <Button
            v-if="Reset"
            type="warning"
            ghost
            class="button"
            @click="click_reset"
          >
            重置
          </Button>
          <Button
            v-if="searchAdd"
            type="success"
            ghost
            class="button"
            @click="click_add"
          >
            新增
          </Button>
        </div>
        <div>
          <Button
            v-if="searchExport"
            type="info"
            class="button"
            @click="click_goexport"
          >
            导出
          </Button>
          <Button
            v-if="searchImport"
            type="primary"
            class="button"
            @click="click_import"
          >
            导入
          </Button>
          <Button
            v-if="batch"
            type="primary"
            class="button"
            @click="click_batch"
          >
            批量打款
          </Button>
          <Button
            v-if="download"
            type="primary"
            class="button"
            @click="click_download"
          >
            下载合同
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 *@TODO 组件可以考虑放入到iview.js中全局可引入
 *@overview 搜索列表封装
 *@author [damon song]
 *@createDate [2020-06-26]
 *@param {String} tabName -tab页标题
 *@param {Boolean} searchAdd -是否显示新增按钮
 *@param {Boolean} searchExport -是否显示导出按钮
 *@param {Boolean} searchImport -是否显示导入按钮
*@param {Boolean} Reset -是否显示重置按钮
 *@param {Function}} search、reset... -按钮对应事件
 *@param {Boolean} batch -是否显示批量按钮
 * @param {Boolean} download -是否显示下载合同按钮
 */
export default {
  props: {
    tabName: {
      type: String,
      required: true
    },
    searchAdd: {
      type: Boolean,
      default: false
    },
    batch: {
      type: Boolean,
      default: false
    },
    download: {
      type: Boolean,
      default: false
    },
    searchExport: {
      type: Boolean,
      default: false
    },
    searchImport: {
      type: Boolean,
      default: false
    },
    search: {
      type: Function
    },
    resets: {
      type: Function
    },
    add: {
      type: Function
    },
    goexport: {
      type: Function
    },
    import: {
      type: Function
    },
    batchs: {
      type: Function
    },
    Reset: {
      type: Boolean,
      default: false
    },
    downloads: {
      type: Function
    }
  },
  methods: {
    click_search () {
      this.$emit("search");
    },
    click_reset () {
      this.$emit("resets");
    },
    click_add () {
      this.$emit("add");
    },
    click_goexport () {
      this.$emit("goexport");
    },
    click_import () {
      this.$emit("import");
    },
    click_batch () {
      this.$emit("batchs");
    },
    click_download () {
      this.$emit("downloads");
    }

  }
};
</script>
<style lang="less" >
.search_container {
  padding: 0 40px 0 40px;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.05);
  border-radius: 6px 6px 0px 0px;
  .margin_bottom {
    margin-bottom: 10px;
  }
  .wrap_search {
    display: flex;
    justify-content: space-between;
    .wrap_slot {
      flex: 1;
    }
    .wrap_button {
      text-align: right;
      .button {
        display: inline-block;
        width: 80px;
        margin-left: 20px;
        margin-bottom: 24px;
      }
    }
  }
}
</style>
